"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _excluded = ["onAccept", "canAccept", "onReject", "canReject", "onApprove", "canRetry", "onRetry", "canApprove", "onReview", "canReview", "onValidate", "canValidate", "onCancel", "canCancel", "onPublishProvisional", "canPublishProvisional", "onPublish", "canPublish", "onClose", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LifeCycleMenuItem = function LifeCycleMenuItem(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color;
  return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    onClick: onClick,
    color: color
  }, label);
};

var TicketActionMenu = function TicketActionMenu(_ref2) {
  var onAccept = _ref2.onAccept,
      canAccept = _ref2.canAccept,
      onReject = _ref2.onReject,
      canReject = _ref2.canReject,
      onApprove = _ref2.onApprove,
      canRetry = _ref2.canRetry,
      onRetry = _ref2.onRetry,
      canApprove = _ref2.canApprove,
      onReview = _ref2.onReview,
      canReview = _ref2.canReview,
      onValidate = _ref2.onValidate,
      canValidate = _ref2.canValidate,
      onCancel = _ref2.onCancel,
      canCancel = _ref2.canCancel,
      onPublishProvisional = _ref2.onPublishProvisional,
      canPublishProvisional = _ref2.canPublishProvisional,
      onPublish = _ref2.onPublish,
      canPublish = _ref2.canPublish,
      onClose = _ref2.onClose,
      labels = _ref2.labels,
      props = _objectWithoutProperties(_ref2, _excluded);

  var handleClick = function handleClick(action) {
    return function () {
      onClose();
      action();
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Menu, _extends({
    onClose: onClose
  }, props), canAccept ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onAccept),
    label: labels.accept
  }) : '', canReject ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onReject),
    label: labels.reject,
    color: "secondary"
  }) : '', canApprove ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onApprove),
    label: labels.approve
  }) : '', canRetry ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onRetry),
    label: labels.retry
  }) : '', canReview ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onReview),
    label: labels.review
  }) : '', canValidate ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onValidate),
    label: labels.validate
  }) : '', canCancel ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onCancel),
    label: labels.cancel,
    color: "secondary"
  }) : '', canPublishProvisional ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onPublishProvisional),
    label: labels.publishProvisional
  }) : '', canPublish ? /*#__PURE__*/_react["default"].createElement(LifeCycleMenuItem, {
    onClick: handleClick(onPublish),
    label: labels.publish
  }) : '');
};

TicketActionMenu.propTypes = {
  canAccept: _propTypes["default"].bool,
  canApprove: _propTypes["default"].bool,
  canCancel: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  canPublish: _propTypes["default"].bool,
  canPublishProvisional: _propTypes["default"].bool,
  canReject: _propTypes["default"].bool,
  canRetry: _propTypes["default"].bool,
  canReview: _propTypes["default"].bool,
  canValidate: _propTypes["default"].bool,
  labels: _propTypes["default"].object.isRequired,
  onAccept: _propTypes["default"].func,
  onApprove: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  onPublish: _propTypes["default"].func,
  onPublishProvisional: _propTypes["default"].func,
  onReject: _propTypes["default"].func,
  onRetry: _propTypes["default"].func,
  onReview: _propTypes["default"].func,
  onValidate: _propTypes["default"].func,
  ticket: _propTypes["default"].object,
  user: _propTypes["default"].object
};
var _default = TicketActionMenu;
exports["default"] = _default;